<template>
  <div class="main-action">
    <slot name="entry-btn">
      <button class="entry-btn" @click="handleJump" v-if="!isWeixin" :style="{backgroundImage: `url(${btnImgUrl})`, backgroundColor: btnBgColor}">{{btnText}}</button>
      <button class="entry-btn" @click="handleCopy" v-else :style="{backgroundImage: `url(${btnImgUrl})`, backgroundColor: btnBgColor}">{{btnText}}</button>
    </slot>
    <div class="flex main-btns justify-center items-center">
      <slot name="share-btn" v-if="!!this.activityConfig.posterBgImg">
        <button @click="handleShare">分享海报</button>
      </slot>
      <slot name="copy-btn" v-if="this.mainActData.pwd">
        <button @click="handleCopy">复制淘口令</button>
      </slot>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  import * as types from '@/store/types'

  export default {
    name: 'MainAction',
    data() {
      return {
      }
    },
    props: {
      options: {
        type: Object,
        default () {
          return {}
        }
      },
      btnText: {
        type: String,
        default: '进入主会场'
      },
      btnImgUrl: {
        type: String
      },
      btnBgColor: {
        type: String
      }
    },
    computed: {
      ...mapState([
        'activityConfig',
        'userInfo',
        'mainActData'
      ]),
      ...mapGetters([
        'isWeixin'
      ]),
      text () {
        return this.activityConfig.mainCopyTemp ? this.activityConfig.mainCopyTemp.replace(/\[PWD\]/, this.mainActData.pwd) : this.mainActData.pwd
      }
    },
    methods: {
      ...mapMutations([
        types.SET_MAIN_ACT,
        'showPosterModal',
        'showCopyModal'
      ]),
      ...mapActions(['handleJumpAction', 'handleCopyAction', 'handleShareAction']),
      handleJump () {
        this.handleJumpAction({
          url: this.mainActData.url
        })
      },
      handleCopy () {
        if (this.mainActData.pwd) {
          this.handleCopyAction({
            copyText: this.text
          })
        }
      },
      handleShare () {
        this.handleShareAction({
          shareImgUrl: this.activityConfig.shareImgUrl,
          copyText: this.text,
          showModal: true
        })
      },
    },
    async created () {
      
    },
  }
</script>

<style scoped lang="less">
  .main-action {
    font-size: 0;
    text-align: center;
    margin-bottom: .26rem;
    .entry-btn {
      width: 6.03rem;
      height: .86rem;
      font-size: .4rem;
      color: #fff;
      background: url(//xwstatic.js571.com/2020/yh/activity/38/button.png) no-repeat;
      background-size: 100%;
      border-radius: .4rem;
    }
    .main-btns {
      margin-top: .26rem;
      button {
        width: 2.86rem;
        height: .8rem;
        margin: 0 .1rem;
        font-size: .4rem;
        color: #fff;
        border: 1px solid #fff;
        border-radius: .4rem;
        background: transparent;
      }
    }
  }
</style>
